import React from 'react';

interface LicenseDetailShellProps {
  children: React.ReactNode;
}

const LicenseDetailShell: React.FC<LicenseDetailShellProps> = ({ children }) => {
  return <>{children}</>;
};

export default LicenseDetailShell;
